import { notificationSuccess } from 'app/core/toast';
import { useGetApplication } from 'app/hooks';
import { useNavigate } from 'react-router-dom';

import type Paginated from '../../../core/paginable';
import { messages, messagesKey } from '../../translation';

import {
  createFormStatement,
  deleteFormStatement,
  updateFormStatement
} from './services/formAdministration.service';
import { baseUrl } from './http';
import { type FormStatement } from './types';

export const useFormStatement = (id: string) => {
  const [{ data, loading, error, response }] = useGetApplication<Paginated<FormStatement>>({
    url: baseUrl,
    params: {
      id,
      page: 1,
      pageSize: 1
    }
  });

  const [form] = data?.data || [];

  return { loading, data: form, error, response };
};

export const useGetAllFormStatement = (loadMode = true) => {
  const [{ data, loading, error, response }] = useGetApplication<Array<FormStatement>>(
    {
      url: `${baseUrl}/all`,
      params: undefined
    },
    loadMode
  );

  return { loading, data: data, error, response };
};

export const useFormStatementActions = () => {
  const navigate = useNavigate();

  const save = async (formStatement: FormStatement, redirectPath: string) => {
    if (formStatement.id) {
      await updateFormStatement(formStatement.id, formStatement);
    } else {
      await createFormStatement(formStatement);
    }

    notificationSuccess(messages(messagesKey.savedSucessfully));
    navigate(redirectPath);
  };

  const remove = async (id: string, redirectPath: string) => {
    await deleteFormStatement(id);
    notificationSuccess(messages(messagesKey.deletedSucessfully));
    navigate(redirectPath);
  };

  return { save, remove };
};
